import React from 'react';
import {Accion} from '../comun/Index';
import './estilos.css';
import axios from 'axios';

const getFecha = function(fecha, hora = false){
  const fechaN = new Date(fecha);
  const fechaTexto = fechaN.toLocaleDateString('es-AR');
  const horaTexto = fechaN.toLocaleTimeString('es-AR');
  let cadena = fechaTexto;
  if (hora) cadena += ' ' + horaTexto;
  return cadena
}

const getDetalles = function(oficio_id){
  return new Promise((resolve, reject) => {
    const url = localStorage.getItem('apiUrl') + '/oficios/todos/detalles'
    const config = {
      headers:{authorization:sessionStorage.getItem('token')},
      params:{oficio_id}
    };
    axios.get(url, config)
    .then((res) => {
      if (res.data.status === "ok"){
        resolve(res.data.detalles)
      } else {
        reject(res.data.error)
      }
    })
    .catch((error) => reject(error))
  })
}

const estados = [
  {id:1, descripcion:'Observado'},
  {id:2, descripcion:'Derivado'},
  {id:3, descripcion:'Parcial'},
  {id:4, descripcion:'Finalizado'}
]

export default class Listado extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      expandir:null,
      loading:false,
      detalles:null
    }
  }

  expandir(index, oficio_id){
    const {expandir} = this.state;
    if (expandir !== index){
      this.detalles(oficio_id);
      this.setState({expandir:index});
    } else {
      this.setState({detalles:null,expandir:null});
    }
  }
  
  detalles(oficio_id){
    this.setState({loading:true})
    getDetalles(oficio_id)
    .then((detalles) => this.setState({loading:false, detalles}))
    .catch((error) => {
      alert("Ocurrió un error");
      console.log(error);
    })
  }

  // getEstado(estado_id){
  //   const estado = estados.find((item, index) => item.id == estado_id).descripcion;
  //   return(estado);
  // }

  completar(juzgado, defensoria){
    let emisor = '';
    if (juzgado !== undefined && juzgado !== null){
      emisor = `Juz.: ${juzgado.nombre} ${juzgado.distrito} `
    } else {
      emisor = `Def.: ${(defensoria.localidad !== null ? defensoria.localidad : defensoria.nombre)}`
    }
    return (emisor)
  }
  
  render(){
    const {expandir, detalles, loading} = this.state;
    const {
      oficios, mesa, realizarPase, 
      establecerRecordatorio, agregarPersonas,
      subir, descargar
    } = this.props;
    return(
      <div className="Lista">
        {oficios?.length > 0 && oficios.map((item, index) => {
          return(
            <div
              key={index}
              className="Item"
              style={{backgroundColor:index%2===1?'#e3e3e3':'#f0f0f0'}}
            >
              <div className="Detalles">
                <div style={{display:'flex', flexDirection:'row', alignItems:'flex-end'}}>
                  <Accion
                    icono={expandir === index ? 'keyboard_arrow_up': 'keyboard_arrow_down'}
                    ayuda="Expandir"
                    backgroundColor="lightgrey"
                    disabled={false}
                    onClick={() => this.expandir(index, item.id)}
                  />
                  {`(${item.id}) Oficio N°${item.numero} - Exp ${item.numero_exp}/${item.anio_exp}   - ${item.caratula} - ${this.completar(item.juzgado,item.defensoria)}`}
                </div>
                <div className="Acciones">
                  <span style={{color:'grey', fontStyle:'italic', fontSize:14}}>{item.ultimo_pase.estado}</span>
                  {(!mesa && item.archivos) &&
                    <Accion
                      icono="file_download"
                      ayuda="Descargar archivos"
                      backgroundColor="#00E896"
                      disabled={false}
                      onClick={() => descargar(item.id)}
                    />
                  }
                  <Accion
                    icono="file_upload"
                    ayuda="Subir archivos"
                    backgroundColor="#00E896"
                    disabled={false}
                    onClick={() => subir(item.id)}
                  />
                  <Accion
                    icono="person_add"
                    ayuda="Agregar personas"
                    backgroundColor="#00a5e5"
                    disabled={false}
                    onClick={() => agregarPersonas(item.id)}
                  />
                  {!mesa &&
                    <Accion
                      icono="watch_later"
                      ayuda="Establecer recordatorio"
                      backgroundColor="#00a5e5"
                      disabled={false}
                      onClick={() => establecerRecordatorio(item.id)}
                    />
                  }
                  <Accion
                    icono="send"
                    ayuda="Realizar pase"
                    backgroundColor="orange"
                    disabled={false}
                    onClick={() => realizarPase(item.id)}
                  />
                </div>
              </div>
              {expandir === index &&
                <div className="Preguntas">
                  {detalles !== null && 
                    <>
                      {(detalles.plazo_horas !== undefined && detalles.plazo_horas !== null && detalles.plazo_horas != '0') &&
                        <span style={{fontSize:18, fontWeight:'bold', color:'darkred'}}>Vencimiento: <strong>{detalles.plazo_horas}Hs. {detalles.habil ? 'Habiles' : 'Corridas'}</strong></span>
                      }
                      <span>Caratula: <strong>{detalles.caratula}</strong></span>
                      <span>Fecha ingreso: <strong>{getFecha(detalles.fecha_ingreso, true)}</strong> - Fecha oficio: <strong>{getFecha(detalles.fecha)}</strong></span>
                      {(detalles.juzgado !== undefined && detalles.juzgado !== null) &&
                        <span>Juzgado: <strong>{`Nro: ${detalles.juzgado.numero} - ${detalles.juzgado.nombre} - distrito ${detalles.juzgado.distrito} - ${detalles.juzgado.materia}`}</strong></span>
                      }
                      {(detalles.defensoria !== undefined && detalles.defensoria !== null) &&
                        <span>Defensoría: <strong>{(detalles.defensoria.localidad !== null ? detalles.defensoria.localidad : detalles.defensoria.nombre)}</strong></span>
                      }
                      <div className='Personas'>
                        <span>Personas:</span>
                        {detalles.personas?.length > 0 && detalles.personas.map((persona, index) => {
                          return(
                            <li style={{marginLeft:17}}><strong>{`${persona.documento} - ${persona.apellidos}, ${persona.nombres}`}</strong></li>
                          )
                        })}
                      </div>
                      <div className='Personas'>
                        <span>Pases:</span>
                        {detalles.pases?.length > 0 && detalles.pases.map((pase, index) => {
                          return(
                            <li style={{marginLeft:17}}><strong>{`${getFecha(pase.fecha, true)} - ${pase.area} - ${pase.estado} ${pase.observaciones? ' - ' + pase.observaciones:""}`}</strong></li>
                          )
                        })}
                      </div>
                      {(detalles.observaciones !== undefined && detalles.observaciones !== null) &&
                        <span>Observaciones: <strong>{detalles.observaciones}</strong></span>
                      }
                    </>
                  }
                  {(detalles === null && loading) && 
                    <span>Cargando...</span>
                  }
                </div>
              }
            </div>
          )
        })}
      </div>
    );
  }

}
